import { createSlice } from '@reduxjs/toolkit';
import { setLocalStorage } from '../../helpers/jsHelper';
import { convertStripeCentsToAmount } from '../../screens/subscriptionComponents/subscriptionHelper';
import { LogConsole } from '../../helpers/logEvents';

const initialState = {
  data: null,
  billingInfo: null,
  updateBillingInfoAPI:false,
  userPlanLoading: true,
  userPlanDetailsLoading: true,
  plans: [],
  userSelectedPlans: [],
  browsePlans: false,
  showContactForm: false,
  showEnterpriseForm: false,
  showCardForm: false,
  callCheckoutAPI:null,
  cardList: {},
  addOnsList: {},
  cardAddons: {},
  refetchCard: false,
  addOnsSuccessFlag: {
    flag: false,
    message: ""
  },
  planUpgraded: {
    upgrade: false,
    downgrade: false,
  },
  allProductsUsedCount: [],
  allCustomProductsUsedCount: [],
  freemiumProductsUsedCount: [],
  PurchasedAddOnsList: {},
  PurchasedOneTimeAddOnsList: {},
  addOnsIntervalViaSave: null,
  oneTimeAddOnForBuyMore: null,
  freemiumFeatures: [],
  failedSubscriptions: [],
  showProductUsageHistory: false,
  hasAutomationsData: false,
  hubspotItem:null,
  purchasedUploadLimitPlanList: [],
  allPurchasedPlanList: [],
  segmentDataForBilling: null,
  isDefault3DCard: true,
  imagineCreditLimit:[]
};

const subscription = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    resetState: (state) => {
      return {
        ...initialState,
      };
    },
    setData: (state, { payload }) => {
      state.data = payload;
    },
    setRefetchCardFlag: (state, { payload }) => {
      state.refetchCard = payload;
    },
    setPlans: (state, { payload }) => {
      state.plans = payload;
    },
    setPlanDetailsLoading: (state, { payload }) => {
      state.userPlanDetailsLoading = payload;
    },
    setUserSelectedPlans: (state, { payload }) => {
      const sortedData = payload?.sort((a, b) => +b?.recurring_interval - +a?.recurring_interval);
      window.$priceDetails = {}
      state.userSelectedPlans = sortedData;
      state.userPlanLoading = false;
    },
    setBrowsePlans: (state, { payload }) => {
      state.browsePlans = payload;
    },
    setContactFormDialogOpen: (state, { payload }) => {
      state.showContactForm = payload;
    },
    setEnterpriseFormDialogOpen: (state, { payload }) => {
      state.showEnterpriseForm = payload;
    },
    setShowCardForm: (state, { payload }) => {
      state.showCardForm = payload;
    },
    setMakeCheckoutAPICall: (state, { payload }) => {
      state.callCheckoutAPI = payload;
    },
    setPaymentCardList: (state, { payload }) => {
      state.cardList = payload;
    },
    setProductAddonsList: (state, { payload }) => {
      state.addOnsList = payload;
    },
    setCartAddonsList: (state, { payload }) => {
      state.cardAddons = payload;
    },
    setBillingInfo: (state, { payload }) => {
      state.billingInfo = { ...state.billingInfo, ...payload };
    },
    setUpdateBillingInfo: (state, { payload }) => {
      state.updateBillingInfoAPI = payload
      state.billingInfo = { ...state.billingInfo, makeAPI:!state.billingInfo.makeAPI}
    },
    SetAddOnsSuccessFlag: (state, { payload }) => {
      state.addOnsSuccessFlag = { ...state.addOnsSuccessFlag, ...payload };
    },
    PlanUpgraded: (state, { payload }) => {
      state.planUpgraded = { ...state.planUpgraded, ...payload };
    },
    setProductsUsedCount: (state, { payload }) => {
      state.allProductsUsedCount = payload;
    },
    setAllCustomProductsUsedCount: (state, { payload }) => {
      state.allCustomProductsUsedCount = payload;
    },
    setFreemiumProductsUsedCount: (state, { payload }) => {
      state.freemiumProductsUsedCount = payload;
    },
    SetAllPurchasedAddonsList: (state, { payload }) => {
      state.PurchasedAddOnsList = payload;
    },
    SetAllPurchasedOneTimeAddonsList: (state, { payload }) => {
      state.PurchasedOneTimeAddOnsList = payload;
    },
    SetAddOnsQtyIntervalViaSave: (state, { payload }) => {
      state.addOnsIntervalViaSave = payload;
    },
    SetAddOnsQtyIntervalCountViaSave: (state, { payload }) => {
      state.addOnsIntervalCountViaSave = payload;
    },
    SetOneTimeAddOnForBuyMore: (state, { payload }) => {
      state.oneTimeAddOnForBuyMore = payload;
    },
    setFreemiumFeatures: (state, { payload }) => {
      state.freemiumFeatures = payload;
    },
    setFailedSubscriptions: (state, { payload }) => {
      state.failedSubscriptions = payload;
    },
    setShowProductUsageHistory: (state, { payload }) => {
      state.showProductUsageHistory = payload ? true : false;
    },
    setAutomationsData: (state, { payload }) => {
      state.hasAutomationsData = payload;
    },
    setHubspotItem: (state, {payload}) => {
      state.hubspotItem = payload;
    },
    setPurchasedUploadLimitPlan: (state, {payload}) => {
      state.purchasedUploadLimitPlanList = payload;
    },
    setAllPurchasedListPlan: (state, {payload}) => {
      state.allPurchasedPlanList = payload;
    },
    setSegmentDataForBilling: (state, { payload }) => {
      state.segmentDataForBilling = payload;
    },
    setThreeDCardActive: (state, { payload }) => {
      state.isDefault3DCard = payload;
    },
    setImagineCreditLimit: (state, { payload }) => {
      state.imagineCreditLimit = payload;
    }
  },
});

export const {
  setContactFormDialogOpen,
  setEnterpriseFormDialogOpen,
} = subscription.actions;

export const subscriptionActions = subscription.actions;
export const subscriptionSelector = (state) => state.subscription;
export const subscriptionReducer = subscription.reducer;
export default subscriptionReducer;

export const selectIsThreeDCardActive = (state) => state.subscription.isDefault3DCard;
export const selectIsContactFormOpen = (state) => state.subscription.showContactForm;
export const selectIsEnterpriseFormOpen = (state) => state.subscription.showEnterpriseForm;
export const selectIsBrowsingPlans = (state) => state.subscription.browsePlans;
export const selectIsCardForm = (state) => state.subscription.showCardForm;
export const selectIsMakeCheckoutAPICall = (state) => state.subscription.callCheckoutAPI;
export const selectGetCardList = (state) => state.subscription.cardList;
export const selectAddonsList = (state) => state.subscription.addOnsList;
export const selectCartAddonsList = (state) => state.subscription.cardAddons;
export const selectRefetchCard = (state) => state.subscription.refetchCard;
export const selectHubspotItem = (state) => state.subscription.hubspotItem;

export const selectPlanList = (state) => state.subscription.plans;
export const selectHasAutomationsData = (state) => state.subscription.hasAutomationsData;

// user plans
export const selectIsUserHaveNotAnyPlan = (state) =>
  state.subscription.userSelectedPlans.filter(a => !a.is_cancelled).length === 0;
export const selectIsExpiredList = (state) =>
  state.subscription.userSelectedPlans.filter(a => a.is_cancelled).length !== 0;
export const selectUserPlanList = (state) => state.subscription.userSelectedPlans;
export const selectUserPlanLoading = (state) => state.subscription.userPlanLoading;
export const selectUserPlanDetailsLoading = (state) => state.subscription.userPlanDetailsLoading;
export const selectUserActivePlanDetails = (state) => {
  const plans = selectPlanList(state);
  const userPlans = selectUserPlanList(state);
  const activePlan = userPlans.filter(
    (a) => a.is_upload_limit_plan && !a.is_cancelled
  )?.[0] || userPlans.filter(
    (a) => a.is_active_main_subscription_plan && !a.is_cancelled
  )?.[0];
  // const isTexturePlan = activePlan?.plan_details?.[0]?.is_textile_plan;
  // if (isTexturePlan === true || isTexturePlan === 'true')
  //   setLocalStorage('isTexturePlan', isTexturePlan);
  // else setLocalStorage('isTexturePlan', false);

  const activePlanId = +activePlan?.plan_details?.[0]?.plan_id; //selectUserActiveSubscriptionPlanId(state);
  const activePriceId = +activePlan?.plan_details?.[0]?.price_id; //selectUserActiveSubscriptionPlanPriceId(state);
  const activePrice = plans
    ?.find((a) => a.id === activePlanId)
    ?.pricing_details?.find((b) => b.id === activePriceId);
  const isTexturePlan = activePrice?.is_textile_plan;
  const activePriceAmount = convertStripeCentsToAmount(activePrice?.unit_amount);
  const isActivePlanAI = activePlan?.plan_details?.[0]?.is_ai_plan;

  // LogConsole('DEBUG___activePrice', {
  //   userPlans,
  //   plans,
  //   activePlan,
  //   activePrice,
  //   activePlanId,
  //   activePriceAmount,
  //   activePriceId,
  // });

  const order = activePrice?.plan_order;
  if (order) setLocalStorage('planOrderId', order);
  else setLocalStorage('planOrderId', 0);

  setLocalStorage('planPriceId', activePriceId || null);
  setLocalStorage('planPriceAmount', activePriceAmount || 0);
  setLocalStorage('isTexturePlan', isTexturePlan || false);
  setLocalStorage('isActivePlanAI', isActivePlanAI || false);

  return activePlan || null;
};
export const selectIsCreatorPlan = (state) => {
  const userPlans = selectUserPlanList(state);
  const flag = userPlans?.some((a) => a.plan_details.some((b) => b.is_custom_plan));
  return flag || false;
};
export const selectIsUserHaveActivePlanScheduledToCancel = (state) => {
  const plan = selectUserActivePlanDetails(state);
  return plan?.cancel_at_period_end || false;
};
export const selectUserActivePlanSubscriptionId = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return plans?.id || null;
};
export const selectUserActiveSubscriptionPlanId = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return +plans?.plan_details?.[0]?.plan_id || null;
};
export const selectUserActiveSubscriptionPlanPriceId = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return +plans?.plan_details?.[0]?.price_id || null;
};
export const selectUserActiveSubscriptionPlanPriceAmount = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return +plans?.plan_details?.[0]?.price_amount || null;
};
export const selectUserActivePlanSubscriptionName = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return plans?.plan_details?.[0]?.plan_name || null;
};
export const selectUserActivePlanSubscriptionAI = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return plans?.plan_details?.[0]?.is_ai_plan || false;
};
export const selectUserActiveSubscriptionSelfServePlan = (state) => {
  const plans = selectPlanList(state);
  const activePlanId = selectUserActiveSubscriptionPlanId(state);
  const activePriceId = selectUserActiveSubscriptionPlanPriceId(state);
  const activePrice = plans
    ?.find((a) => a.id === activePlanId)
    ?.pricing_details?.find((b) => b.id === activePriceId);

  return activePrice?.is_self_serve_plan;
};

export const selectUserActivePlanSubscriptionRecurringInterval = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return plans?.recurring_interval || null;
};
export const selectUserActivePlanSubscriptionRecurringIntervalCount = (state) => {
  const plans = selectUserActivePlanDetails(state);
  return plans?.recurring_interval_count || null;
};
export const selectUserActivePlanSubscriptionOrderId = (state) => {
  const plans = selectPlanList(state);
  const activePlanId = selectUserActiveSubscriptionPlanId(state);
  const activePriceId = selectUserActiveSubscriptionPlanPriceId(state);
  const activePrice = plans
    ?.find((a) => a.id === activePlanId)
    ?.pricing_details?.find((b) => b.id === activePriceId);
  const isTexturePlan = activePrice?.is_textile_plan;
  const activePriceAmount = convertStripeCentsToAmount(activePrice?.unit_amount);

  // LogConsole('DEBUG___activePrice', {
  //   // plans,
  //   activePrice,
  //   activePlanId,
  //   activePriceAmount,
  //   activePriceId,
  // });

  const order = activePrice?.plan_order;
  if (order) setLocalStorage('planOrderId', order);
  else setLocalStorage('planOrderId', 0);

  setLocalStorage('planPriceId', activePriceId || null);
  setLocalStorage('planPriceAmount', activePriceAmount || 0);
  setLocalStorage('isTexturePlan', isTexturePlan || false);
  return order || null;
};

export const selectHighestPlanOrderId = (state) => {
  const plans = selectPlanList(state);
  let highestOrderId = 0;
  plans.forEach(plan => {
    plan.pricing_details.forEach(price => {
      const order = parseInt(price.plan_order, 10);
      if(order > highestOrderId) {
        highestOrderId = order;
      }
    })
  });

  return highestOrderId !== 0 ? highestOrderId : 0;
};

export const selectHighestPlanPriceAmount = (state) => {
  const plans = selectPlanList(state);
  let highestAmount = 0;
  plans.forEach((plan) => {
    plan.pricing_details.forEach((price) => {
      const amount = parseInt(price.unit_amount, 10);
      if (amount > highestAmount) {
        highestAmount = amount;
      }
    });
  });

  return highestAmount !== 0 ? highestAmount : 0;
};

export const selectBillingInfo = (state) => state.subscription.billingInfo;
export const selectUpdateBillingStatus = (state) => state.subscription.updateBillingInfoAPI;
export const selectDefaultPaymentMethod = (state) => {
  const cardList = selectGetCardList(state)?.results || [];
  return cardList.find((a) => a?.is_default === true);
};
export const selectAddOnSuccessFlag = (state) => state.subscription.addOnsSuccessFlag;
export const selectPlanUpgradedFlag = (state) => state.subscription.planUpgraded;

export const selectAllProductsUsedCount = (state) => state.subscription.allProductsUsedCount;
export const selectAllCustomProductsUsedCount = (state) => state.subscription.allCustomProductsUsedCount;
export const selectFreemiumProductsUsedCount = (state) => state.subscription.freemiumProductsUsedCount;

export const selectAllFreemiumSubscriptionsAndCustomProductsUsedCount = (state) => {
  const products = selectAllProductsUsedCount(state);
  const customProducts = selectAllCustomProductsUsedCount(state); // commented as we are getting the all product count (including manually) from product-used-count api
  const freemiumProducts = selectFreemiumProductsUsedCount(state);
  return [...products, ...customProducts, ...freemiumProducts];
}

const extraListBasedOnName = (list, name) => {
  if (!list || !name) return [];
  const uniqueNameList = list.filter((a) => a?.basemodeltype?.toLowerCase() === name?.toLowerCase());
  let newList = [];

  uniqueNameList.map((a) => {
    const i = newList.findIndex((b) => b?.basemodeltype?.toLowerCase() === a?.basemodeltype?.toLowerCase());
    if (i !== -1) {
      newList[i] = {
        ...newList[i],
        available_count: newList?.[i]?.available_count + a.available_count,
        total_count: newList?.[i]?.total_count + a.total_count,
        used_count: newList?.[i]?.used_count + a.used_count,
      };
    } else {
      newList.push(a);
    }
  });

  return newList;
};

export const select3DViewerAR = (state) =>
  extraListBasedOnName(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), '360 Viewer + AR');

export const selectConfigurator = (state) =>
  extraListBasedOnName(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), 'configurator');

export const selectEditors = (state) =>
  extraListBasedOnName(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), 'editor');

export const select3DModels = (state) =>
  extraListBasedOnName(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), "3d model");

export const select3DModelVariations = (state) =>
  extraListBasedOnName(
    selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state),
    '3d model variation'
  );

export const select3DViewer = (state) =>
  extraListBasedOnName(
    selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state),
    '3D Viewer'
  );

export const selectAvailable3DModelVariations = (state) => {
  const list = select3DModelVariations(state);
  return Math.floor(list.reduce((a, c) => a + Number(c.available_count), 0) / 2);
};

export const selectAvailable3DModelVariationsWithoutDivide = (state) => {
  const list = select3DModelVariations(state);
  return Math.floor(list.reduce((a, c) => a + Number(c.available_count), 0));
};

export const select3DModelUploadLimit = (state) =>
  extraListBasedOnName(
    selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state),
    '3d models upload limit'
  );

export const selectAvailable3DModelUploadLimit = (state) => {
  const list = select3DModelUploadLimit(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

export const selectAIVideos = (state) =>
  extraListBasedOnName(
    selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state),
    'ai video'
  );

export const selectVideos = (state) =>
  extraListBasedOnName(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), 'video');

// 3D Viewer + AR Addons
export const selectTotal3DViewerAR = (state) => {
  const list = select3DViewerAR(state);
  return list.reduce((a, c) => a + Number(c.total_count), 0);
};
export const selectUsed3DViewerAR = (state) => {
  const list = select3DViewerAR(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};
export const selectAvailable3DViewerAR = (state) => {
  const list = select3DViewerAR(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

// 3D Viewer
export const selectAvailable3DViewer = (state) => {
  const list = select3DViewer(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

// Configurator Addons
export const selectTotalConfigurator = (state) => {
  const list = selectConfigurator(state);
  return list.reduce((a, c) => a + Number(c.total_count), 0);
};
export const selectUsedConfigurator = (state) => {
  const list = selectConfigurator(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};
export const selectAvailableConfigurator = (state) => {
  const list = selectConfigurator(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

// AI Video Addons
export const selectTotalAIVideo = (state) => {
  const list = selectAIVideos(state);
  return list.reduce((a, c) => a + Number(c.total_count), 0);
};
export const selectUsedAIVideo = (state) => {
  const list = selectAIVideos(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};
export const selectAvailableAIVideo = (state) => {
  const list = selectAIVideos(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

// Video Addons
export const selectTotalVideo = (state) => {
  const list = selectVideos(state);
  return list.reduce((a, c) => a + Number(c.total_count), 0);
};
export const selectUsedVideo = (state) => {
  const list = selectVideos(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};
export const selectAvailableVideo = (state) => {
  const list = selectVideos(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

// Editor Addons
export const selectTotalEditors = (state) => {
  const list = selectEditors(state);
  return list.reduce((a, c) => a + Number(c.total_count), 0);
};
export const selectUsedEditors = (state) => {
  const list = selectEditors(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};

// Texture Addons
export const selectTextures = (state) =>
  extraListBasedOnName(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), 'texture');
export const selectTotalTextures = (state) => {
  const list = selectTextures(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};
export const selectUsedTextures = (state) => {
  const list = selectTextures(state);
  return list.reduce((a, c) => a + Number(c.used_count), 0);
};
export const selectAvailableTextures = (state) => {
  const list = selectTextures(state);
  return list.reduce((a, c) => a + Number(c.available_count), 0);
};

const extraListOfExcludedNameList = (list, names) => {
  if (!list || !names) return [];
  const uniqueNameList = list.filter((a) => !names.includes(a.name.toLowerCase()));
  let newList = [];

  uniqueNameList.map((a) => {
    const i = newList.findIndex((b) => b.name.toLowerCase() === a.name.toLowerCase());
    if (i !== -1) {
      newList[i] = {
        ...newList[i],
        available_count: newList?.[i]?.available_count + a.available_count,
        total_count: newList?.[i]?.total_count + a.total_count,
        used_count: newList?.[i]?.used_count + a.used_count,
      };
    } else {
      newList.push(a);
    }
  });

  return newList;
};

export const selectAdditionalProducts = (state) =>
  extraListOfExcludedNameList(selectAllFreemiumSubscriptionsAndCustomProductsUsedCount(state), ['texture', 'editor', '3d model']);

export const selectPurchaseAddOns = (state) => state.subscription.PurchasedAddOnsList;
export const selectPurchaseOneTimeAddOns = (state) => state.subscription.PurchasedOneTimeAddOnsList


export const selectAddOnsIntervalViaSave = (state) => state.subscription.addOnsIntervalViaSave;
export const selectAddOnsIntervalCountViaSave = (state) => state.subscription.addOnsIntervalCountViaSave;
export const selectOneTimeAddOnForBuyMore = (state) => state.subscription.oneTimeAddOnForBuyMore;
export const selectFreemiumFeatures = (state) => state.subscription.freemiumFeatures;
export const selectFailedSubscriptions = (state) => state.subscription.failedSubscriptions;
export const selectProductUsageHistorySelector = (state) =>
  state.subscription?.showProductUsageHistory;
export const selectPurchasedUploadLimitPlanListSelector = (state) =>
  state.subscription?.purchasedUploadLimitPlanList;
export const selectSegmentDataForBilling = (state) => state.subscription?.segmentDataForBilling
export const selectAllPurchasedPlanListSelector = (state) =>
  state.subscription?.allPurchasedPlanList;
export const selectImagineCreditLimit = (state) => state.subscription.imagineCreditLimit;

